import {Button, Card, Stack, Typography} from "@mui/material";
import React, {useState} from "react";
import {pageAuthorizedByGroup} from "../fragments/PageAuthorization";
import {Link} from "react-router-dom";
import {FolderShared, LocalActivity, SettingsSuggest, ViewWeek, Work} from "@mui/icons-material";
import {translateFunction} from "../../localization/TranslationService";
import {EnvironmentStage} from "../../data/EnvironmentStage";

const translate = translateFunction("SureBasePortalProductsCatalog");

/*
* overview
*
* products
* products/:id
* suppliers
* suppliers/:id
*
* forms
*   - table with all forms
*
* forms/:id
*   - full form definition
*   - preview of how it would look like
*
* questions
*   - table with all questions
*
* questions/:id
*   - full question definition
*   - preview of how it would look like
*
* */

export const ProductModuleOverview = pageAuthorizedByGroup(function() {
	useState<string>("");
	return <>
		<Stack direction={"row"} justifyContent={"space-evenly"} style={{width: "100%"}}>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "150px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<FolderShared fontSize={"large"}/>
						<Typography>{translate("Suppliers")}</Typography>
					</div>
					<Stack direction={"row-reverse"}>
						<Button component={Link} to={"./suppliers"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "150px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<Work fontSize={"large"}/>
						<Typography>{translate("Products")}</Typography>
					</div>
					<Stack direction={"row-reverse"}>
						<Button component={Link} to={"./products"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "150px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<SettingsSuggest fontSize={"large"}/>
						<Typography>{translate("Comparator Configs")}</Typography>
					</div>
					<Stack direction={"row-reverse"}>
						<Button component={Link} to={"./comparatorconfigs"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "150px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<LocalActivity fontSize={"large"}/>
						<Typography>{translate("Incentives")}</Typography>
					</div>
					<Stack direction={"row-reverse"}>
						<Button component={Link} to={"./incentives"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "150px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<LocalActivity fontSize={"large"}/>
						<Typography>{translate("Custom attribute setup")}</Typography>
					</div>
					<Stack direction={"row-reverse"}>
						<Button component={Link} to={"./custom_attribute_setup"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "150px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<ViewWeek fontSize={"large"}/>
						<Typography>{translate("Changes")}</Typography>
					</div>
					<Stack direction={"row-reverse"}>
						<Button component={Link} to={"./deploy"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
		</Stack>
	</>;
}, ["Admin", "Product"]);

export const productsEditorDefaultTargetStage: EnvironmentStage = "dev";
export const productsEditorTargetStage = "kizidev";
